import React from 'react'
import styled from 'styled-components'
import { gameProgressState } from '../../state';
import { useRecoilState } from 'recoil';


const StyledModal = styled.div`
  z-index: 999;
  position: absolute;
  ${({ gameProgress }) => (gameProgress === 'intro' || gameProgress === 'intro2') && 'position: fixed;'}
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment')  && 'left: 10px;'}
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment')  && 'right: 10px;'}
  margin: auto;
  ${({ gameProgress }) => (gameProgress === 'intro' || gameProgress === 'intro2') && 'border: 0;'}
  ${({ gameProgress }) => gameProgress === 'result' && 'border: solid 15px #bfbfbf;'}
  ${({ gameProgress }) => (gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment') && 'border: solid 15px #8cc63f;'}
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment')  && 'border-radius: 20px;'}
  
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${({ gameProgress }) => (gameProgress === 'intro' || gameProgress === 'intro2')  && 'justify-content: center;'}
  align-items: center;
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment') && 'max-width: 650px;'}
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment') && 'max-height: 1000px;'}
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment') && 'height: fit-content;'}
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment') && 'padding: 12px 12px 24px 12px;'}
  ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment') && 'margin-top: 32px;'}
  
  
  ${({ gameProgress }) => (gameProgress === 'intro' || gameProgress === 'intro2') && 'background: rgba(0, 0, 0, 0.7);' }
  ${({ gameProgress }) => gameProgress === 'result' && 'background: #f2f2f2;'}
  ${({ gameProgress }) => gameProgress === 'main' && 'background: #f3f9eb;'}
  ${({ gameProgress }) => (gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment') && 'background: #f3f9eb;' }
  overflow: scroll;
  text-align: center;
  ${({ gameProgress }) => (gameProgress === 'intro' || gameProgress === 'intro2')  && 'color: #ffffff;'}
  ${({ gameProgress }) => (gameProgress === 'intro' || gameProgress === 'intro2')  && 'font-size: 18px;'}
  @media screen and (-ms-high-contrast: active),(-ms-high-contrast: none){
    ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment')  && 'left: 25%;'}
    ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment')  && 'right: 25%;'}

    ${({ gameProgress }) => (gameProgress === 'result' || gameProgress === 'education' || gameProgress ==='land' || gameProgress ==='life' || gameProgress ==='society' || gameProgress ==='environment')  && 'min-width: 500px;'}
  }
`;

const CloseButton = styled.div`
${({ gameProgress }) => (gameProgress === 'intro' || gameProgress === 'intro2' || gameProgress === 'result') && 'display:none;'}
`;

const Modal = ({ show, onClose, children }) => {
  const [gameProgress] = useRecoilState(gameProgressState);
  if (!show) {
    return null;
  }

  return (
    <StyledModal gameProgress={gameProgress}>
      {children}
      <CloseButton gameProgress={gameProgress}><button onClick={onClose} className="close-button"><img src="img/cancel.png" className="close-button-pic" alt='close' /></button></CloseButton>
    </StyledModal>
  );
}

export {
  Modal
}
